import { useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { FavoredBadge } from '@/components/FavoredBadge';
import Button from '@/components/core/Button';
import { getFavoredBearerLabel } from '@/helpers/bearers';

interface FavoredBearerActionProps {
  bearer: {
    id: string;
    name?: string;
    serial?: string;
  };
  isFavored: boolean;
  canSet?: boolean;
  isPending?: boolean;
  onSetFavored: (bearerId: string) => void;
}

export const FavoredBearerAction = ({
  bearer,
  isFavored,
  canSet = false,
  isPending = false,
  onSetFavored,
}: FavoredBearerActionProps) => {
  const { formatMessage } = useIntl();

  const handleSetFavored = useCallback(() => {
    onSetFavored(bearer.id);
  }, [bearer.id, onSetFavored]);

  if (isFavored) {
    return <FavoredBadge />;
  }

  if (!canSet) {
    return null;
  }

  const bearerLabel = getFavoredBearerLabel(bearer);
  const accessibleName = bearerLabel
    ? formatMessage(
        { defaultMessage: 'Gör till föredragen: {bearer}' },
        { bearer: bearerLabel },
      )
    : formatMessage({ defaultMessage: 'Gör till föredragen' });

  return (
    <Button
      type="button"
      size="sm"
      variant="outline"
      loading={isPending}
      aria-label={accessibleName}
      onClick={handleSetFavored}
    >
      <FormattedMessage defaultMessage="Gör till föredragen" />
    </Button>
  );
};
